import { clearAllCookies } from './forceLogout';

const AUTH_STORAGE_KEY = 'auth';

/**
 * The storage event covers changes made by another tab, but browsers do not
 * reliably dispatch it when site data is deleted through browser settings.
 * Recheck whenever the page is activated so those external clears are detected
 * as well.
 */
export const trackAuthFlag = (): (() => void) => {
  let wasAuthenticated = window.localStorage.getItem(AUTH_STORAGE_KEY) === 'true';
  let isLoggingOut = false;

  console.log('wasAuthenticated =>', wasAuthenticated);

  const updateAuthState = (isAuthenticated: boolean): void => {
    const authWasCleared = wasAuthenticated && !isAuthenticated;
    wasAuthenticated = isAuthenticated;

    if (authWasCleared && !isLoggingOut) {
      isLoggingOut = true;
      clearAllCookies();
      window.location.href = `${window.API_URL}/api/logout`;
    }
  };

  const checkAuthFlag = (): void => {
    updateAuthState(window.localStorage.getItem(AUTH_STORAGE_KEY) === 'true');
  };

  const handleStorageChange = (event: StorageEvent): void => {
    if (event.storageArea !== window.localStorage) return;

    if (event.key === AUTH_STORAGE_KEY) {
      updateAuthState(event.newValue === 'true');
    } else if (event.key === null) {
      updateAuthState(false);
    }
  };

  const handleVisibilityChange = (): void => {
    if (!document.hidden) checkAuthFlag();
  };

  window.addEventListener('storage', handleStorageChange);
  window.addEventListener('focus', checkAuthFlag);
  window.addEventListener('pageshow', checkAuthFlag);
  document.addEventListener('visibilitychange', handleVisibilityChange);

  return () => {
    window.removeEventListener('storage', handleStorageChange);
    window.removeEventListener('focus', checkAuthFlag);
    window.removeEventListener('pageshow', checkAuthFlag);
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  };
};
